import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Switch, Select } from 'antd'
import { FlowActions } from '../../../features/flow/actions'
import { Row } from '../../../components/Grid'
import { Col } from 'styled-bootstrap-grid'
import { getFlowValidationResult, selectedFlow } from '../../../features/flow/selectors'
import { HookActions } from '../../../features/hook/actions'
// import { getHooks } from '../../../features/hook/selectors'
import { isValidating } from '../../../features/theme/selectors'
import { LoadingOverlay } from '../../../components/Loading/LoadingOverlay'
import styled from 'styled-components/macro'
import { CenteredRow, Label } from '../../../components/Page/Layout'
import { NavProps, WizardNavigationWrapper, WizardNav } from '../../../components/Wizard/WizardNav'
import _ from 'lodash'
import { SelectValue } from 'antd/lib/select'
import { fetchProfilePatterns } from '../../../api/profilePattern'
import TextArea from 'antd/lib/input/TextArea'
import { fixedProfilesPerAppearanceMainstream } from './data'

const { Option } = Select

const RightDiv = styled.div`
  float: right;
`

const ColumnWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-row-gap: 40px;
  grid-template-columns: 1fr 1fr 1fr;

  /* div {
    text-align: center;
  } */
  .ant-switch {
    margin-top: 6px;
    margin-bottom: 6px;
  }
`

const StyledSelect = styled(Select)`
  width: 200px;
`
type ProfilePatternResp = {
  id: number
  name: string
  sequence: any
}

type AddFlowHooksProps = {
  close?: () => void
} & NavProps

export const AddFlowHooks: React.FC<AddFlowHooksProps> = ({ close, ...rest }: AddFlowHooksProps) => {
  const dispatch = useDispatch()
  const loading = useSelector(isValidating)
  const status = useSelector(getFlowValidationResult)
  const flow = useSelector(selectedFlow)

  const [profilePatterns, setProfilePatterns] = useState<ProfilePatternResp[]>([])
  const [profileRatings, setPtofileRatings] = useState('')

  //   const hooks = useSelector(getHooks)

  useEffect(() => {
    let load = false
    const loadData = async () => {
      if (!load) {
        const pp = await fetchProfilePatterns()
        if (pp && pp.data) {
          setProfilePatterns(pp.data.profilePatterns)
        }
        dispatch(HookActions.fetchHooks())
        load = true
      }
    }
    loadData()
  }, [dispatch])

  function changeConfig(data: any) {
    if (flow && flow.name) {
      const oldValue = flow.config
      const flowToValidate = { ...flow, config: { ...oldValue, ...data } }
      dispatch(FlowActions.updateNewFlow(flowToValidate))
      console.log(flowToValidate, data)
    }
  }

  const changeProfilePatternSelect = (id: any) => {
    if (flow && flow.name) {
      const oldValue = flow.profile
      const selectedProfilePattern = profilePatterns.find(p => p.id === +id)
      const profileEnabled = oldValue?.enabled || false
      const profileHook = oldValue?.hook || 4

      if (selectedProfilePattern) {
        const data = {
          profilePatternId: id,
          profilePatternSequence: selectedProfilePattern.sequence
        }
        const flowToValidate = {
          ...flow,
          profile: { ...oldValue, ...data, enabled: profileEnabled, hook: profileHook }
        }

        dispatch(FlowActions.updateNewFlow(flowToValidate))
      } else {
        console.log('NOT found', id)
      }
    }
  }

  if (!flow) return <LoadingOverlay loading>&nbsp;</LoadingOverlay>

  return (
    <LoadingOverlay loading={loading}>
      <div className="mt40">
        <CenteredRow>Configurazione 1</CenteredRow>
        <Row>
          <Col md={8} mdOffset={2}>
            <ColumnWrapper>
              <div>
                <Label>Richiesta foto profilo utente</Label>
                <Switch
                  checkedChildren={<span>Attiva</span>}
                  unCheckedChildren={<span>Disattiva</span>}
                  defaultChecked
                  checked={flow.config?.profilePhotoRequired || false}
                  onChange={(c: boolean) => {
                    changeConfig({
                      profilePhotoRequired: c
                    })
                  }}
                />
              </div>
              <div>
                <Label>Frame Iupay Blu</Label>
                <Switch
                  checkedChildren={<span>Attiva</span>}
                  unCheckedChildren={<span>Disattiva</span>}
                  defaultChecked
                  checked={flow.config?.blueFrame || false}
                  onChange={(c: boolean) => {
                    changeConfig({
                      blueFrame: c
                    })
                  }}
                />
              </div>
              <div style={{ gridColumn: '1/2' }}>
                <Label>Rating</Label>
                <Switch
                  checkedChildren={<span>Attiva</span>}
                  unCheckedChildren={<span>Disattiva</span>}
                  defaultChecked
                  checked={flow.config?.withRating || false}
                  onChange={(c: boolean) => {
                    changeConfig({
                      withRating: c,
                      fixedProfilesPerAppearance: c ? fixedProfilesPerAppearanceMainstream : undefined
                    })
                  }}
                />
              </div>
              <div>
                <Label>Rating Totale</Label>
                <Switch
                  checkedChildren={<span>Attiva</span>}
                  unCheckedChildren={<span>Disattiva</span>}
                  defaultChecked
                  disabled={!flow.config?.withRating}
                  checked={flow.config?.withTotalRating || false}
                  onChange={(c: boolean) => {
                    changeConfig({
                      withTotalRating: c
                    })
                  }}
                />
              </div>
              <div>
                <Label>Profile Pattern Sequence</Label>
                <StyledSelect
                  disabled={!flow.config?.withRating}
                  value={flow?.profile?.profilePatternId || ''}
                  onChange={(value: SelectValue) => {
                    changeProfilePatternSelect(value)
                  }}
                >
                  {_.map(profilePatterns, (p: ProfilePatternResp) => (
                    <Option key={p.id} value={p.id}>
                      {p.name}
                    </Option>
                  ))}
                </StyledSelect>
              </div>
            </ColumnWrapper>
          </Col>
        </Row>
        <WizardNavigationWrapper>
          <WizardNav {...rest} nextDisabled={!status?.isValid} />
        </WizardNavigationWrapper>
      </div>
      <RightDiv>
        <Button onClick={close}>Chiudi</Button>
      </RightDiv>
    </LoadingOverlay>
  )
}
